import ActionTypes from '../constants';

const initialState = {
    leaseBatches: {},
    leaseBatch: {},
    invoicesByPartner: {}
    // loading: false,
};

const leaseBatchReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETLEASEBATCHSUCCESS:
            return {
                ...state,
                leaseBatches: action.payload,
            }
        case ActionTypes.GETLEASEBATCHBYIDSUCCESS:
            return {
                ...state,
                leaseBatch: action.payload,
            }
        case ActionTypes.GETINVOICESBYPARTNERIDSUCCESS:
            return {
                ...state,
                invoicesByPartner: action.payload,
            }
        default:
            return state;
    }
}

export default leaseBatchReducer;